export const CLIENT_CONTACT_TYPES = [
    'phone',
    'email',
    'instagram',
    'twitter',
    'facebook',
    'linkedin',
    'viber',
    'whatsapp',
    'telegram',
    'website',
    'other',
];
export const CLIENT_CONTACT_VALUE_LIMITS = {
    phone: 16,
    email: 250,
    instagram: 2500,
    twitter: 2500,
    facebook: 2500,
    linkedin: 2500,
    viber: 25,
    whatsapp: 25,
    telegram: 250,
    website: 1000,
    other: 250,
};
export const isClientContactType = (value) => CLIENT_CONTACT_TYPES.includes(value);
const isEmailValue = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
const isHttpUrl = (value) => {
    try {
        const url = new URL(value);
        return url.protocol === 'http:' || url.protocol === 'https:';
    }
    catch {
        return false;
    }
};
export const normalizeContactValue = (type, rawValue) => {
    let value = `${rawValue || ''}`.trim();
    if (!value)
        return '';
    const maxLength = CLIENT_CONTACT_VALUE_LIMITS[type];
    if (type === 'phone' || type === 'viber' || type === 'whatsapp') {
        value = value.replace(/(?!^)\+/g, '').replace(/[^0-9+]/g, '');
        if (value && !value.startsWith('+'))
            value = `+${value.replace(/^\+/, '')}`;
        return value.slice(0, maxLength);
    }
    if (type === 'telegram') {
        value = value.replace(/^@+/, '').replace(/[^a-zA-Z0-9_]/g, '');
        return value ? `@${value}`.slice(0, maxLength) : '';
    }
    if (type === 'instagram' ||
        type === 'twitter' ||
        type === 'facebook' ||
        type === 'linkedin' ||
        type === 'website') {
        if (value.startsWith('https://') || value.startsWith('http://'))
            return value.slice(0, maxLength);
        return value ? `https://${value.replace(/^https?:\/\//, '')}`.slice(0, maxLength) : '';
    }
    return value.slice(0, maxLength);
};
export const validateContactValue = (type, rawValue) => {
    const value = normalizeContactValue(type, rawValue);
    if (!value)
        return 'required';
    if (value.length > CLIENT_CONTACT_VALUE_LIMITS[type])
        return 'maxLength';
    switch (type) {
        case 'phone':
        case 'viber':
        case 'whatsapp':
            return /^\+[0-9]{7,15}$/.test(value) ? null : 'phone';
        case 'email':
            return isEmailValue(value) ? null : 'email';
        case 'telegram':
            return /^@[a-zA-Z0-9_]{4,32}$/.test(value) ? null : 'telegram';
        case 'instagram':
        case 'twitter':
        case 'facebook':
        case 'linkedin':
        case 'website':
            return isHttpUrl(value) ? null : 'url';
        case 'other':
            return null;
        default:
            return 'required';
    }
};
